
// 精选图书引入图片
import moduleTitle from '../assets/img/home/study_center_title.png'
import L0 from '../assets/img/home/study1.png'
import L1 from '../assets/img/home/study2.png'
import L2 from '../assets/img/home/study3.png'
import L3 from '../assets/img/home/study4.png'

export default {
    namespaced:true,
    state:{        
        Imglist:
        {   
            moduleTitle:moduleTitle,
            list:[
                {id:'1',level:L0},
                {id:'2',level:L1},
                {id:'3',level:L2},
                {id:'4',level:L3},            
            ]
        }
        
    }
}